import React, { useRef } from 'react';
import { ArrowLeftIcon, ArrowRightIcon, CalendarDaysIcon } from 'lucide-react';
import { upcomingClasses } from '../../data/classes';
import { CALENDAR_URL } from '../../data/site';
import { ClassCard } from '../shared/ClassCard';
import { SectionHeading } from '../ui/SectionHeading';
export function NextClasses() {
  const scroller = useRef<HTMLUListElement>(null);
  const scrollBy = (dir: 1 | -1) => {
    const el = scroller.current;
    if (!el) return;
    el.scrollBy({
      left: dir * el.clientWidth * 0.8,
      behavior: 'smooth'
    });
  };
  return <section className="section bg-mist" aria-labelledby="next-classes-title" data-id="element-192" data-mp="2r5lkab9xrsct">
      <div className="gutter" data-id="element-193" data-mp="2de6v1mpfquxb">
        <SectionHeading id="next-classes-title" title="Classes Fill Fast — Reserve Your Seat" intro="Upcoming group classes at Bass Pro Shops – Silverton." action={<div className="flex items-center gap-3" data-id="element-195" data-mp="28dso67zklr0v">
              <a href={CALENDAR_URL} className="inline-flex items-center gap-2 font-display text-base font-semibold uppercase tracking-wider text-navy underline-offset-4 hover:underline" data-id="element-196" data-mp="28chig2mke974">
                <CalendarDaysIcon className="h-5 w-5 text-accent" aria-hidden="true" data-id="element-197" data-mp="32u1p7e9ypbio" /> See Full Calendar
              </a>
              <div className="ml-3 hidden gap-2 md:flex" data-id="element-198" data-mp="3gs8ei60ui36q">
                <button type="button" onClick={() => scrollBy(-1)} aria-label="Scroll classes left" className="flex h-11 w-11 items-center justify-center rounded-full border border-navy/20 bg-white text-navy hover:border-navy" data-id="element-199" data-mp="3bwayk0thuyuh">
                  <ArrowLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-200" data-mp="2k5wpqj0c8cpo" />
                </button>
                <button type="button" onClick={() => scrollBy(1)} aria-label="Scroll classes right" className="flex h-11 w-11 items-center justify-center rounded-full border border-navy/20 bg-white text-navy hover:border-navy" data-id="element-201" data-mp="2xwrwnpra0jqm">
                  <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-202" data-mp="20g2xy4xmhxlg" />
                </button>
              </div>
            </div>} data-id="element-194" data-mp="2hdo56tft4g8t" />
      </div>
      <ul ref={scroller} className="no-scrollbar mt-10 flex snap-x snap-mandatory gap-4 overflow-x-auto px-[clamp(1rem,4vw,7rem)] pb-4 [scroll-padding-inline:clamp(1rem,4vw,7rem)]" aria-label="Upcoming classes" data-id="element-203" data-mp="4coekw5wr033">
        {upcomingClasses.map(s => <li key={s.id} className="w-[min(85vw,22rem)] shrink-0 snap-start 3xl:w-[24rem]" data-id="element-204" data-mp="j0ja0kbavijv">
            <ClassCard session={s} data-id="element-205" data-mp="3hkrqv7o1c5uc" />
          </li>)}
      </ul>
    </section>;
}